import React, { Component } from "react";
import axios from "axios";
import styles from "./styles/ViewTalent.scss";
import Select from "react-select";
import Loader from "../../Loader/Loader";
import sectors from "../Careers/Sectors";
import skills from "./Skills";
import experience from "./Experience";
import classnames from "classnames";
import BackToDashboard from "./BackToDashboard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAddressCard, faTable } from "@fortawesome/free-solid-svg-icons";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import DecModal from "./DecModal";

export default class ViewTalent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			sectors: [],
			skills: [],
			experience: [],
			nominees: [],
			employers: [],
			tableview: false,
			emailList: []
		};
	}

	componentDidMount = () => {
		axios
			.post("/api/kingstonconnect/getallnominees/")
			.then(res => {
				this.setState({ nominees: res.data });
			})
			.catch(e => {
				this.setState({ error_saving: true, saved_recently: false });
				console.log(e);
			});

		axios
			.post("/api/kingstonconnect/getallemployers/")
			.then(res => {
				this.setState({
					employers: res.data
				});
			})
			.catch(e => console.log(e));
	};

	handleSectorSelect = e => {
		this.setState({
			sectors: e
		});
	};

	handleSkillSelect = e => {
		this.setState({
			skills: e
		});
	};

	handleExperienceSelect = e => {
		this.setState({
			experience: e
		});
	};

	filter = (selected, nominee) => {
		if (nominee.length === 0 && selected.length > 0) {
			return false;
		} else {
			let display = true;
			let i = 0;
			let length = selected.length;

			for (i; i < length; i++) {
				let j = 0;
				let nom_length = nominee.length;

				for (j; j < nom_length; j++) {
					if (nominee[j] === selected[i]) {
						display = true;
						break;
					} else {
						display = false;
					}
				}
				if (display === false) {
					return false;
				}
			}
		}
		return true;
	};

	intersection = (n_sectors, n_skills, n_experience) => {
		// Sectors
		let nominee_sectors = n_sectors.map(a => a.label);
		let selected_sectors = this.state.sectors.map(a => a.label);

		// Skills
		let nominee_skills = n_skills.map(a => a.label);
		let selected_skills = this.state.skills.map(a => a.label);

		// Experience
		let nominee_experience = n_experience.value;
		let selected_experience = this.state.experience.value;

		let sector_display = this.filter(selected_sectors, nominee_sectors);
		let skill_display = this.filter(selected_skills, nominee_skills);

		let experience_display = true;

		if (selected_experience !== undefined) {
			experience_display = nominee_experience === selected_experience;
		}

		if (sector_display && skill_display && experience_display) {
			return true;
		} else {
			return false;
		}
	};

	compare = (a, b) => {
		return a.label > b.label ? 1 : b.label > a.label ? -1 : 0;
	};

	date = (a, b) => {
		// Sort profles in decreasing order of update date
		if (a.update_date > b.update_date) return -1;
		if (a.update_date < b.update_date) return 1;
		return 0;
	};

	addToEmailList = email => {
	 let emailList = this.state.emailList;
	 emailList.push(email);
	 this.setState({
		 emailList: emailList
	 });
	}

	removeFromEmailList = email => {
		let emailList = this.state.emailList;
		let index = emailList.indexOf(email);
		emailList.splice(index, 1);
		this.setState({
			emailList: emailList
		});
	}

	removeAllFromEmailList = () => {
		this.setState({
			emailList: []
		});
	}


	sendEmail = () => {
		let emailList = this.state.emailList;
		let length = emailList.length;
		let i = 0;
		let string = "mailto:?bcc="
		for (i; i<length; i++ ) {
			string += emailList[i] + ";";
		}
		window.location.href = string;
	}

	render() {
		if (this.state.nominees.length === 0) {
			return <Loader />;
		} else {
			return (
				<div className={styles.page}>
					<h1>
						<strong>
							Kingston
							<span style={{ color: "#007D99" }}>
							Connect
							</span>
						</strong>{" "}
						Talent Pool
					</h1>
					<BackToDashboard />
					{/*
        <h3>The following people have been nominated as excellent employees.</h3>
        */}
					<div className={styles.filterSectors}>
						<div className="row">
							<div className="col-sm-4">
								<h6>{"Filter by Sector:"}</h6>
								<Select
									onChange={this.handleSectorSelect}
									value={this.state.sectors}
									options={sectors.slice(1)}
									isMulti={true}
									id="sectors"
									isSearchable
								/>
							</div>

							<div className="col-sm-4">
								<h6>{"Filter by Skill:"}</h6>
								<Select
									onChange={this.handleSkillSelect}
									value={this.state.skills}
									options={skills.sort(this.compare)}
									isMulti={true}
									id="skills"
									isSearchable
								/>
							</div>

							<div className="col-sm-4">
								<h6>{"Filter by Experience:"}</h6>
								<Select
									onChange={this.handleExperienceSelect}
									value={this.state.experience}
									options={experience}
									isMulti={false}
									id="experience"
									isSearchable
								/>
							</div>
						</div>

						<br />

						{!this.state.tableview && (
							<div
								onClick={() =>
									this.setState({ tableview: true })
								}
								style={{ cursor: "pointer" }}
							>
								<FontAwesomeIcon
									icon={faTable}
									size={this.state.iconSize}
								/>
								{" - Table View"}
							</div>
						)}
						{this.state.tableview && (
							<div
								onClick={() =>
									this.setState({ tableview: false })
								}
								style={{ cursor: "pointer" }}
							>
								<FontAwesomeIcon
									icon={faAddressCard}
									size={this.state.iconSize}
								/>
								{" - Card View"}
							</div>
						)}
					</div>
					<button onClick={this.sendEmail} className="btn btn-primary mx-5">Email Nominees ({this.state.emailList.length})</button>
					<button onClick={this.removeAllFromEmailList} className="btn btn-danger mx-5">Empty Email List</button>

					{!this.state.tableview && (
						<div className="row">
							{this.state.nominees
								.sort(this.date)
								.map((n, key) => {
									console.log(n)
									let profile = (
										<div
											key={key}
											className="col-sm-4 mt-4"
										>
											<div
												className={classnames(
													"card",
													styles.card
												)}
											>
												<div className="card-body">
													{n.first_name &&
														n.last_name && (
															<h5 className="card-title">
																{n.first_name +
																	" " +
																	n.last_name}
															</h5>
														)}
													{n.linkedin &&
														n.linkedin !== "" && (
															<h6>
																<a
																	target="_blank"
																	href={
																		n.linkedin
																	}
																>
																	<FontAwesomeIcon
																		icon={
																			faLinkedin
																		}
																	/>
																	{
																		" LinkedIn"
																	}
																</a>
															</h6>
														)}
													{n.phone && (
														<h6>{n.phone}</h6>
													)}
													{ !this.state.emailList.includes(n.email) &&
													<h6>
														<small> Click to add to email List </small><br/>
														<button className="btn btn-primary" onClick={() => this.addToEmailList(n.email)}>
															{n.email}
														</button>
													</h6>
													}
													{ this.state.emailList.includes(n.email) &&
													<h6>
														<small> Click to remove from email list </small><br/>
														<button className="btn btn-danger" onClick={() => this.removeFromEmailList(n.email)}>
															{n.email}
														</button>
													</h6>
													}
													{n.education && (
														<h6>
															{"Education: " +
																n.education}
														</h6>
													)}
													{n.recent_position && (
														<h6>
															{"Most Recent Position: " + n.recent_position}
														</h6>
													)}
													{n.experience && (
														<h6>
															{"Experience: " +
																n.experience
																	.value}
														</h6>
													)}
													<h6>
														Sectors:
														{n.sectors.map(
															(sec, key) => (
																<span
																	key={key}
																	className={classnames(
																		"badge badge-info",
																		styles.sector
																	)}
																>
																	{sec.label}
																</span>
															)
														)}
													</h6>
													{n.skills.length !== 0 && (
														<h6>
															Skills:
															{n.skills.map(
																(sec, key) => (
																	<span
																		key={
																			key
																		}
																		className={classnames(
																			"badge badge-secondary",
																			styles.sector
																		)}
																	>
																		{
																			sec.label
																		}
																	</span>
																)
															)}
														</h6>
													)}
													<p className="card-text">
														{n.description}
													</p>
													{n.declaration !== undefined &&
														<DecModal
															display="disabled"
															declaration={n.declaration}
														/>
													}
												</div>
												<div className="card-footer">
													{n.job_applied && (
														<h6 className="card-subtitle mb-2">
															{"Job Applied For: " +
																n.job_applied}
														</h6>
													)}

													<h6 className="card-subtitle mb-2 text-muted">
														{this.state.employers.map(
															(emp, key) => {
																if (
																	emp._id ===
																	n.nominator
																) {
																	let emp_info = (
																		<p
																			key={
																				key
																			}
																		>
																			Nominated
																			By:{" "}
																			{
																				emp.first_name
																			}{" "}
																			{
																				emp.last_name
																			}{" "}
																			<br />
																			Email:{" "}
																			{
																				emp.email
																			}
																		</p>
																	);
																	return emp_info;
																}
																return [];
															}
														)}
													</h6>
													<h6 className="card-subtitle mb-2">
														{n.reference ? "Reference: " + n.reference : undefined}
													</h6>
													<h6 className="card-subtitle mb-2 text-muted">
														{n.nomination_date
															? "Date Nominated: " +
															  n.nomination_date
															: undefined}
													</h6>
													<h6 className="card-subtitle mb-2 text-muted">
														{n.update_date
															? "Profile Updated: " +
															  n.update_date
															: undefined}
													</h6>
													{
														n.auth_invite === true &&
														<span className="badge badge-success mb-2">
															Authenticated
														</span>
													}
												</div>
											</div>
										</div>
									);
									if (
										n.update_date !== undefined &&
										n.archive !== true
									) {
										let intersection = this.intersection(
											n.sectors,
											n.skills,
											n.experience
										);
										if (intersection) {
											return profile;
										}
									} else {
										return [];
									}
									return null;
								})}
						</div>
					)}

					{this.state.tableview && (
						<table className="table">
							<thead>
								<tr>
									<th scope="col">First</th>
									<th scope="col">Last</th>
									<th scope="col">Email</th>
									<th scope="col">Phone</th>
									<th scope="col">Sectors</th>
									<th scope="col">Experience</th>
									<th scope="col">Most Recent Position</th>
									<th scope="col">Nominator</th>
									<th scope="col">Nomination Date</th>
									<th scope="col">Update Date</th>
								</tr>
							</thead>
							<tbody>
								{this.state.nominees.sort(this.date).map(n => {
									let row = (
										<tr key={n._id}>
											<td>{n.first_name}</td>
											<td>{n.last_name}</td>
											<td>
												<a href={"mailto:" + n.email}>
													{n.email}
												</a>
											</td>
											<td>{n.phone}</td>
											<td>
												{n.sectors
													.map(a => a.label)
													.join(", ")}
											</td>
											<td>{n.experience && n.experience.label}</td>
											<td>{n.recent_position}</td>
											<td>
												{
													this.state.employers.map(
													emp => {
														if (
															emp._id ===
															n.nominator
														) {
															return (
																emp.first_name +
																" " +
																emp.last_name
															);
														}
														return [];
													}
												)
											}
											{n.nominator.split(' ')[1] !== undefined &&
												n.nominator.split(' ')[0] + " " + n.nominator.split(' ')[1]
											}
											</td>
											<td>{n.nomination_date}</td>
											<td>{n.update_date}</td>
										</tr>
									);

									if (
										n.update_date !== undefined &&
										n.archive !== true
									) {
										let intersection = this.intersection(
											n.sectors,
											n.skills,
											n.experience
										);
										if (intersection) {
											return row;
										}
									} else {
										return [];
									}
									return null;
								})}
							</tbody>
						</table>
					)}
					<br />
				</div>
			);
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/KingstonConnect/ViewTalent.js